export const disputesHandler = {
    pathPattern: '/brands/:brandId/billing/disputes',
    toWeb: ({ brandId }) => ({ path: `/brands/${brandId}/billing/disputes` }),
    meta: {
        title: 'Payment disputes',
        description: 'Opens the brand payment disputes list in the dashboard.',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [
            { name: 'brandId', in: 'path', required: true },
            { name: 'locationId', in: 'query', required: false },
        ],
        example: {
            params: { brandId: 'BXqExampleBrandId' },
            query: { locationId: 'exampleLocationId' },
        },
    },
};
//# sourceMappingURL=disputes.js.map